import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './common/stylus/reset.css'
import './common/stylus/base.styl'
import axios from 'axios'
import 'vant/lib/index.css';
import './common/icon/iconfont.css'
Vue.prototype.$axios = axios
// 本地接口测试
axios.defaults.baseURL = process.env.NODE_ENV == "development" ? 'http://32.wowoxi.com:8888/new_project/new_happytalk_h5/new_pay/dist/pay' : ''
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
